module.exports = __webpack_public_path__ + "img/delete.4eba033d.svg";